import { StepActivity } from './steps.model';

export class GroupedSessions {
  preparation?: SessionTask[];
  experimentation?: SessionTask[];
  practice?: SessionTask[];
  consultation?: SessionTask[];
  evaluation?: SessionTask[];
  order?: number;
}

export class Session {
  order?: number;
  items?: SessionTask[];
}

export class SessionTask {
  order?: number;
  type?: number;
  activity?: StepActivity;
}

export class SessionEvaluationInstrument {
  id?: string;
  categoryName?: string;
  title?: string;
  isHidden?: boolean;
  link?: string;
  solutionaryLink?: string;
  isSolutionary?: boolean;
  typologyStyle?: string;
  exerciseId?: string;
  resourceUrl?: string;
  totalExcercises?: number;
  completedExcercises?: number;
  isSent?: boolean;
}

export enum StepActivityType {
  PREPARATION = 0,
  EXPERIMENTATION = 1,
  PRACTICE = 2,
  CONSULTATION = 3,
  EVALUATION = 4,
}
